
import { defineComponent, toRefs, ref, inject, watchEffect, computed } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
    props: {
        value: { type: String, default: '' },
        min: { type: Number, default: 0 },
        name: { type: String, default: '' },
        label: { type: String, default: '' },
        placeholder: { type: String, default: 'message.ENTER message.YOUR message.VALUE' },
        required: { type: Boolean, default: false },
        type: { type: String || Number, default: 'text' },
        target: { type: String, default: '' },
        disabled: { type: Boolean, default: false },
        rule: { type: String, default: '' },
        ruleMsg: { type: String, default: 'Invalid data' },
        requiredMsg: { type: String, default: 'message.THIS_FIELD message.IS_REQUIRED' },
        maxlength: { type: Number, default: 0 },
        maxLengthMsg: { type: String, default: 'message.NO_MORE_CHARACTERS' }
    },

    setup(props, context) {
        const { target, value } = toRefs(props);
        const inputValue = ref(value.value);
        const showLimitMessage = ref(false);
        const i18n = useI18n();
        const translate = (msg: string) => {
            if (msg.includes('message.')) {
                const splitKeys = msg.split(' ');
                splitKeys.forEach((item, index, array) => {
                    array[index] = i18n.t(item);
                });
                return splitKeys.join(' ');
            }
            return msg;
        };

        const emitter: any = inject('emitter');

        watchEffect(() => {
            const next = value.value ?? '';
            if (next !== inputValue.value) {
                inputValue.value = next;
                if (props.maxlength && next.length <= props.maxlength) {
                    showLimitMessage.value = false;
                }
            }
        });

        const updateValue = () => {
            if (props.maxlength && (inputValue.value || '').length > props.maxlength) {
                inputValue.value = String(inputValue.value).slice(0, props.maxlength);
                showLimitMessage.value = true;
            } else if (props.maxlength && (inputValue.value || '').length < props.maxlength) {
                showLimitMessage.value = false;
            }
            context.emit(`update:${target.value}`, inputValue.value);
        };

        const blurValue = () => {
            context.emit('blur');
        };

        const formRules = computed(() => {
            const rules: Record<string, any>[] = [
                { required: props.required, message: translate(props.requiredMsg) },
                { type: props.rule, message: props.ruleMsg }
            ];
            if (props.maxlength) {
                rules.push({ max: props.maxlength, message: translate(props.maxLengthMsg) });
            }
            return rules;
        });

        emitter.on('clearInput', () => {
            inputValue.value = '';
            showLimitMessage.value = false;
        });

        return {
            updateValue,
            inputValue,
            translate,
            blurValue,
            formRules,
            showLimitMessage
        };
    }
});
